var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ElectronicDocumentsSuccess"},[_c('e-header',{attrs:{"step":4}}),_c('div',{staticClass:"content"},[_c('el-result',{attrs:{"icon":"success","title":"提交完成","subTitle":"请查看短信根据提示进行操作"}},[_c('template',{slot:"extra"},[_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":_vm.toHome}},[_vm._v("返回首页")])],1)],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }